import { ElementType } from "../dom-tools/ElementType";
import { Timer } from "../tools/Timer";
import { OnAnimationFrame } from "../animation/OnAnimationFrame";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { AnimationFrameEvent } from "../animation/AnimationFrameEvent";
import { HSLColor } from "../colors/HSLColor";
import { LCG, LCGState } from "../random/LCG";
import { Range} from "../geometry/Range";

export class ScreenSaverData
{
  element:HTMLElement;
  repeatDuration:number;
  timer:Timer
  hueRange:Range;
  saturationRange:Range;
  luminanceRange:Range;
}

export class ScreenSaverColors
{
  static readonly type = new ElementType( "screen--saver--colors");
  static readonly repeatDuration = new ElementAttribute( "repeat-duration" );
  static readonly hue = new ElementAttribute( "hue" );
  static readonly saturation = new ElementAttribute( "saturation" );
  static readonly luminance = new ElementAttribute( "luminance" );
  
  static #screenSavers:ScreenSaverData[] = [];
  static #initialized = false;
  static random = new LCG();
  static randomSeed:LCGState;

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    ScreenSaverColors.#initialize( onAnimationFrame );

    ScreenSaverColors.random.setSeedState( ScreenSaverColors.randomSeed );
    ScreenSaverColors.#screenSavers = [];

    ScreenSaverColors.type.forAllInDoc( e => ScreenSaverColors.applyOnElement( e ) );
  }

  static #initialize( onAnimationFrame:OnAnimationFrame )
  {
    if ( ScreenSaverColors.#initialized )
    {
      return;
    }

    ScreenSaverColors.random.warmUp();
    ScreenSaverColors.randomSeed = ScreenSaverColors.random.getSeedState();

    ScreenSaverColors.#initialized = true;
    onAnimationFrame.addListener( ( e )=> ScreenSaverColors.update(e ) );
  }

  static update( e:AnimationFrameEvent )
  {
    ScreenSaverColors.#screenSavers.forEach(
      ( sd )=>
      {
        sd.timer.updateMS( e.deltaTimeMS );

        if ( sd.timer.finished )
        {
          let h = ScreenSaverColors.random.in( sd.hueRange );
          let s = ScreenSaverColors.random.in( sd.saturationRange );
          let l = ScreenSaverColors.random.in( sd.luminanceRange );

          let color = new HSLColor( h, s, l );

          sd.element.style.backgroundColor = color.toString();

          sd.timer.start();
        }

      }
    )
  }

  static applyOnElement( e:Element )
  {
    console.log( "ScreenSaveColor", e );

    let data = new ScreenSaverData();
    data.element = e as HTMLElement;
    data.repeatDuration = ScreenSaverColors.repeatDuration.asNumberFrom( e, 10 );
    data.timer = new Timer( data.repeatDuration );
    data.hueRange = ScreenSaverColors.hue.asRange( e, [ 0, 360 ] );
    data.saturationRange = ScreenSaverColors.saturation.asRange( e, [ 90, 100 ] );
    data.luminanceRange = ScreenSaverColors.luminance.asRange( e, [ 45, 55 ] );
    data.timer.setFinished();
    ScreenSaverColors.#screenSavers.push( data );

  }
}